import React from "react";
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import LanguageIcon from '@mui/icons-material/Language';
import CheckIcon from '@mui/icons-material/Check';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import {useTranslation} from "react-i18next";

const LANGUAGES = [
    {code: "fr", label: "Français", flag: "🇫🇷"},
    {code: "en", label: "English", flag: "🇬🇧"},
];

export default function LngToken() {
    const {t, i18n} = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [lng, setLng] = React.useState("fr");

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    React.useEffect(() => {
        if (lng) {
            i18n.changeLanguage(lng);
        }
    }, [lng]);

    const current = LANGUAGES.find((l) => l.code === lng) || LANGUAGES[0];

    return (
        <>
            <Tooltip title={t("lng.switch") || "Langue"} arrow>
                <Chip
                    icon={<LanguageIcon sx={{fontSize: "1rem !important", ml: "6px !important", color: "white !important"}}/>}
                    label={
                        <Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                            <span>{current.flag}</span>
                            <Typography
                                variant="caption"
                                sx={{
                                    fontWeight: 600,
                                    lineHeight: 1
                                }}>
                                {current.code.toUpperCase()}
                            </Typography>
                            <KeyboardArrowDownIcon
                                sx={{
                                    fontSize: "0.9rem",
                                    transition: "transform 0.2s",
                                    transform: Boolean(anchorEl) ? "rotate(180deg)" : "rotate(0deg)",
                                }}
                            />
                        </Box>
                    }
                    onClick={handleMenu}
                    size="small"
                    variant="outlined"
                    sx={{
                        color: "inherit",
                        borderColor: "rgba(255,255,255,0.5)",
                        cursor: "pointer",
                        height: 32,
                        "& .MuiChip-label": {px: 0.5},
                        transition: "border-color 0.2s, background 0.2s",
                        "&:hover": {
                            bgcolor: "rgba(255,255,255,0.15)",
                            borderColor: "rgba(255,255,255,0.85)",
                        },
                    }}
                />
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                transformOrigin={{vertical: "top", horizontal: "right"}}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                elevation={4}
                slotProps={{
                    paper: {
                        sx: {minWidth: 150, mt: 0.5, borderRadius: 2},
                    },
                }}
            >
                {LANGUAGES.map((language) => (
                    <MenuItem
                        key={language.code}
                        selected={lng === language.code}
                        onClick={() => {
                            setLng(language.code);
                            handleClose();
                        }}
                        sx={{
                            gap: 1.5,
                            py: 1,
                            borderRadius: 1,
                            mx: 0.5,
                            fontWeight: lng === language.code ? 700 : 400,
                            "&.Mui-selected": {
                                bgcolor: "action.selected",
                                "&:hover": {bgcolor: "action.hover"},
                            },
                        }}
                    >
                        <Typography sx={{fontSize: "1.1rem"}}>{language.flag}</Typography>
                        <Typography variant="body2" sx={{flexGrow: 1}}>{language.label}</Typography>
                        {lng === language.code && <CheckIcon fontSize="small" color="primary"/>}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
